import Vue from 'vue'
import VueI18n from "vue-i18n";
import App from './App.vue'
import VuereSource from 'vue-resource'
import infiniteScroll from 'vue-infinite-scroll'
import api from './api' // 导入api接口
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale'
import zh_element from 'element-ui/lib/locale/lang/zh-CN'
import en_element from 'element-ui/lib/locale/lang/en'
import fa_element from 'element-ui/lib/locale/lang/zh-TW'
import 'element-ui/lib/theme-chalk/index.css'
import cookie from './utils/cookies.js'
import uid from './utils/uid.js'
import jsencrypt from 'jsencrypt'
import store from './store'
Vue.use(ElementUI)
Vue.use(VuereSource);
Vue.use(infiniteScroll);
Vue.use(VueI18n)
Vue.config.productionTip = false
//全局方法
Vue.prototype.cookieHelper = cookie;
//随机数
Vue.prototype.uidHelper = uid;
//密码加密
Vue.prototype.jsencryptHelper = jsencrypt;

Vue.prototype.$api = api; // 将api挂载到vue的原型上

const messages = {
    zh_CN:{
        ...zh_element,
    },
    en_US:{
        ...en_element,
    },
    zh_TW:{
        ...fa_element,
    },
}

const i18n = new VueI18n({
    
    

    //locale:'zh_CN',
    locale:localStorage.getItem("command")? localStorage.getItem("command") : "zh_CN",
    messages
})

locale.i18n((key,value)=>i18n.t(key,value))



    //api.mainpageApi.getMainPageConfig(sessionStorage.getItem("langNumber") == null ? "zh_CN" : sessionStorage.getItem("langNumber")).then(response => {
//     api.mainpageApi.getMainPageConfig().then(response => {
//     Vue.prototype.$supMainPageConfig = response.data.data;
//     store.commit('setI18n', response.data.data);
//     console.log(store)
//     new Vue({
//         data: {
//             supMainPageConfig: function () {
//                 api.mainpageApi.getMainPageConfig().then(response => {
//                   return response.data.data
//                 })
//             }
//         },
//         i18n,
//         store,
//         render: h => h(App),
//     }).$mount('#app');
   
// });


api.mainpageApi.getMainPageConfig().then(response => {
    api.mainpageApi.getMainPageConfig().then(response => {
    Vue.prototype.$supMainPageConfig = response.data.data;
    store.commit('setI18n', response.data.data);
    console.log(store)
    new Vue({
        data: {
            supMainPageConfig: function () {
                api.mainpageApi.getMainPageConfig().then(response => {
                  return response.data.data
                })
            }
        },
        i18n,
        store,
        render: h => h(App),
    }).$mount('#app');
   
});
   
});





